<div>
  <submission-loading v-if="!isReadyStateComplete()" :id="$vId(this)" />
  <div v-if="isReadyStateComplete()">
    <div class="mt-block">
      <div class="mt-wrapper">
        <message-history
          :id="$vId(this, 'message-history')"
          v-bind:messageHistory="submission.messageHistory"
        ></message-history>
        <fou-group bottom="medium">
          <fou-container :id="$vId(this, 'family-approve')" cols="12" background padded>
            <template #header>
              <div class="mt-flex mt-flex--middle">
                <h5 class="mt-h5 is10">{{ $t('pages.submissions.review.details.title') }}</h5>
                <button
                  v-if="showRetestButton"
                  :disabled="disableRetest"
                  @click="retestValidation"
                  :class="$style.noMargin"
                  class="mt-button"
                >
                  Retest
                </button>
              </div>
            </template>
            <template #content>
              <div v-if="Object.keys(this.submissionFamily).length !== 0">
                <fou-group v-if="validationWarnings">
                  <v-grid>
                    <v-row>
                      <v-col has="10" off="1">
                        <div class="out-left out-right">
                          <h4 class="mt-serif mt-serif--bold mt-serif--size4 mt-line">
                            {{ $t('pages.submissions.review.font_validator.title') }}
                          </h4>
                          <fou-group>
                            <p>{{ $t('pages.submissions.review.font_validator.description') }}</p>
                          </fou-group>
                          <validator :id="$vId(this, 'overlay')" optimist />
                        </div>
                      </v-col>
                    </v-row>
                  </v-grid>
                </fou-group>
                <fou-group>
                  <preview
                    :id="$vId(this)"
                    class="mt-section"
                    :class="[{[$style.previewFontValidatDivision]: validationWarnings}]"
                  />
                </fou-group>
              </div>
            </template>
          </fou-container>
        </fou-group>
        <fou-modal ref="binaryInfoModal" :id="$vId(this, 'support-review-binary-test')" cols="4">
          <template #content>
            <div :class="$style.slotContentBinary">
              <h3 class="mt-h3" :class="[$style.modalTitle, $style.modalTextColor]">
                {{ $t('pages.submissions.review.binaryInfoModal.title') }}
              </h3>
              <fou-group bottom="medium">
                <div :class="[$style.center, $style.modalTextColor]">
                  <p v-html="$sanitize($t('pages.submissions.review.binaryInfoModal.content'))"></p>
                </div>
              </fou-group>
              <fou-group class="mt-flex mt-flex--between" :class="$style.modalControls">
                <button type="button" @click="hide" class="mt-button">
                  {{ $t('pages.submissions.review.binaryInfoModal.ok') }}
                </button>
              </fou-group>
            </div>
          </template>
        </fou-modal>
        <fou-group bottom="medium" v-if="submission.status !== 'in_review'">
          <v-grid>
            <v-row>
              <v-col has="10" off="1">
                <div class="out-left out-right">
                  <h2 class="mt-h5">{{ $t('pages.submissions.review.sent.title') }}</h2>
                  <button type="button" class="mt-button" @click="navigateToDashboard">
                    {{ $t('pages.submissions.review.action.dashboard') }}
                  </button>
                </div>
              </v-col>
            </v-row>
          </v-grid>
        </fou-group>
        <fou-group bottom="large" v-if="submission.status === 'in_review'">
          <v-grid>
            <v-row>
              <v-col has="10">
                <div class="out-right">
                  <button type="button" class="mt-button" @click="navigateToEdit">
                    {{ $t('pages.submissions.review.action.edit') }}
                  </button>
                </div>
              </v-col>
            </v-row>
          </v-grid>
        </fou-group>
        <fou-group v-if="submission.status === 'in_review'">
          <fou-container :id="$vId(this, 'family-approve')" cols="12" background padded>
            <template #header>
              <div class="mt-flex mt-flex--middle" :class="$style.release">
                <h5 class="mt-h5 mt-serif--bold">{{ $t('pages.submissions.review.approve.title') }}</h5>
                <div class="mt-flex mt-flex--middle mt-flex--end" :class="$style.releaseDate">
                  <span class="mt-serif mt-serif--size4"
                    >{{ $t('pages.submissions.review.approve.release_date') }}</span
                  >
                  <input readonly class="mt-input" :class="$style.releaseDateInput" v-model="releaseDate" />
                </div>
              </div>
            </template>
            <template #content>
              <v-grid>
                <v-row class="mt-group mt-group--bottom-large">
                  <v-col has="10" off="1">
                    <ul class="mt-list" :class="$style.status">
                      <li class="mt-list-item" :class="$style.statusItem">
                        <div
                          :id="$vId(this, 'status-approved')"
                          :class="[$style.statusBox, $style.statusBoxApprove, { [$style.statusBoxApproveChecked]: status === 'approved' }]"
                          @click="toggleStatus('approved')"
                        >
                          <div :class="$style.statusBoxIcon">
                            <review-status-icons
                              :id="$vId(this, 'approved')"
                              status="approved"
                              :list-fill="status === 'approved' ? 'white' : 'grey'"
                              :status-fill="status === 'approved' ? { icon: 'new-blue', bg: 'white' } : null"
                            />
                          </div>
                          <div :class="$style.statusBoxCaption">
                            {{ $t('pages.submissions.review.approve.approve') }}
                          </div>
                        </div>
                      </li>
                      <li class="mt-list-item" :class="$style.statusItem">
                        <div
                          :id="$vId(this, 'status-pending')"
                          :class="[$style.statusBox, $style.statusBoxPending, { [$style.statusBoxPendingChecked]: status === 'in_correction' }]"
                          @click="toggleStatus('in_correction')"
                        >
                          <div :class="$style.statusBoxIcon">
                            <review-status-icons
                              :id="$vId(this, 'in-correction')"
                              status="in_correction"
                              :list-fill="status === 'in_correction' ? 'white' : 'grey'"
                              :status-fill="status === 'in_correction' ? { icon: 'orange', bg: 'white' } : null"
                            />
                          </div>
                          <div :class="$style.statusBoxCaption">
                            {{ $t('pages.submissions.review.approve.pending') }}
                          </div>
                        </div>
                      </li>
                      <li class="mt-list-item" :class="$style.statusItem">
                        <div
                          :id="$vId(this, 'rejected')"
                          :class="[$style.statusBox, $style.statusBoxReject, { [$style.statusBoxRejectedChecked]: status === 'rejected' }]"
                          @click="toggleStatus('rejected')"
                        >
                          <div :class="$style.statusBoxIcon">
                            <review-status-icons
                              :id="$vId(this, 'rejected')"
                              status="rejected"
                              :list-fill="status === 'rejected' ? 'white' : 'grey'"
                              :status-fill="status === 'rejected' ? { icon: 'red', bg: 'white' } : null"
                            />
                          </div>
                          <div :class="$style.statusBoxCaption">
                            {{ $t('pages.submissions.review.approve.reject') }}
                          </div>
                        </div>
                      </li>
                    </ul>
                    <div :class="$style.reviewErrors">
                      <ul class="mt-list" v-if="stepsHasErrors">
                        <li
                          v-for="error in removeDuplicates(errorsLogged)"
                          class="mt-list-item mt-error mt-error--padded mt-line"
                        >
                          <p class="mt-line">{{ error }}</p>
                        </li>
                      </ul>
                    </div>
                  </v-col>
                </v-row>
              </v-grid>
              <VeeForm v-slot="{ errors}">
                <v-grid :class="$style.description">
                  <v-row>
                    <v-col has="10" off="1" :class="$style.noteText">
                      <h6 class="mt-h6 mt-serif--bold">{{ $t('pages.submissions.review.approve.addNote') }}</h6>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col has="10" off="1">
                      <section class="mt-section">
                          <TextEditor :id="$vId(this, 'support-note')" v-model="description"
                            name="support note" rules="max:5000|script_tag_validate" :custom=true maxlength="5000"  rows="9"
                            :errorClass="$style.errorField" :editorToolbar="$root.customToolbar" :editorOptions="options"
                            :input-class="['mt-textarea mt-line', {'mt-input--error': Object.hasOwn(errors, 'support note')}]"
                            :placeholder="$t('pages.submissions.components.confirmation.type_here')">
                          </TextEditor>
                      </section>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col has="10" off="1" :class="$style.supportSubmitButton">
                      <div>
                        <button type="button" class="mt-button" @click="submitReview" :disabled="disableSubmitButton">
                          {{ $t('pages.submissions.review.action.submit') }}
                        </button>
                      </div>
                    </v-col>
                  </v-row>
                </v-grid>
              </VeeForm>
            </template>
          </fou-container>
        </fou-group>
      </div>
    </div>
  </div>
</div>

<!-- retest modal -->
<div id="retest-modal" :class="$style.retestModal">
  <div cols="4" :class="$style.retestModalInnerDiv">
      <div :class="$style.slotContentBinary">
        <h3 class="mt-h3" :class="[$style.modalTitle, $style.modalTextColor]">
          {{ $t('pages.submissions.review.binaryInfoModal.title') }}
        </h3>
        <fou-group bottom="medium">
          <div :class="[$style.center, $style.modalTextColor]">
            <p v-html="$sanitize($t('pages.submissions.review.binaryInfoModal.content'))"></p>
          </div>
        </fou-group>
        <fou-group class="mt-flex mt-flex--between" :class="$style.modalControls">
          <button type="button" @click="closeRetestModal" class="mt-button">
            {{ $t('pages.submissions.review.binaryInfoModal.ok') }}
          </button>
        </fou-group>
      </div>
  </div>
</div>